var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSmallMemoCircleInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.676 1v5.441c-2.057.575-3.559 2.434-3.559 4.622 0 1.64.807 3.09 2.058 3.937H0V1h10.676zM2.224 4.5H1.78v.875h7.118V4.5H2.224zm0 2.625H1.78V8H7.117v-.875H2.224zm0 2.625H1.78v.875H5.338V9.75H2.224zM12.01 15c-1.445 0-2.752-.738-3.475-1.969a3.846 3.846 0 0 1 0-3.937 4.053 4.053 0 0 1 3.475-1.969c1.418 0 2.725.766 3.448 1.969a3.846 3.846 0 0 1 0 3.937A3.983 3.983 0 0 1 12.01 15zm.418-6.125h-.89v.875h.89v-.875zm.027 1.75h-1.334v.875h.445v1.313h-.445v.874H12.9v-.874h-.445v-2.188z",
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallMemoCircleInfo);
export default __webpack_public_path__ + "static/media/icon_small_memo-circle-info.c52c888f14c1a5ffea499a8970ca231b.svg";
export { ForwardRef as ReactComponent };